import type { ApolloCache } from "@apollo/client/cache"

import { RoomTypename } from "shared/types/Project"

import {
  RoomCompleteFragment,
  RoomCompleteFragmentDoc
} from "entities/rooms/graphql/fragments.generated"

export function readRoomCompleteFragment(
  id: string,
  cache: ApolloCache<object>
) {
  const cacheId = cache.identify({ id, __typename: RoomTypename })
  if (!cacheId) {
    return null
  }
  return cache.readFragment<RoomCompleteFragment>(
    {
      id: cacheId,
      fragmentName: "RoomComplete",
      fragment: RoomCompleteFragmentDoc
    },
    true
  )
}
